import * as React from 'react';
import * as styles from '../support.module.scss';
import useSupport from '../../../hooks/useSupport';
import { AppContext } from '../../../shared/app-context';
import { SupportContext } from '../../../shared/support-context';
import SortingOptions from '../../../models/enums/sortingOptions';

interface Props {
  count: number;
}

/**
 * PageCount
 * @function PageCount - Component displaying an option for page size on the support page
 */
const PageCount = ({ count }: Props) => {
  const { fetchSupportTickets } = useSupport();
  const { state } = React.useContext(AppContext);
  const { selectedFilters, orderColumn, searchQuery, pageSize } = React.useContext(SupportContext);
  return (
    <span
      onClick={() =>
        fetchSupportTickets(state.clientId, {
          ...selectedFilters,
          orderColumn,
          searchTerm: searchQuery,
          orderDirection: SortingOptions.Descending,
          startAt: 0,
          count: count
        })
      }
      className={`${styles.pageAmount} ${pageSize === count ? styles.pageAmountActive : ''}`}
    >
      {count}
    </span>
  );
};

export default PageCount;
